import classNames from 'classnames';
import { Button } from 'components/atoms';
import { useTranslation } from 'react-i18next';
import { PiTrash, PiUser } from 'react-icons/pi';
import { IArtistsInBandMutationForm } from 'services/artists/types';
import { STATUS } from 'services/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import './ArtistBandCard.scss';

interface IArtistBandCardProps {
  artist: IArtistsInBandMutationForm;
  displayMode?: boolean;
  onRemove?: () => void;
}

const ArtistBandCard = ({ artist, displayMode, onRemove }: IArtistBandCardProps) => {
  const { t } = useTranslation();

  return (
    <div className={classNames('artist-band-card')}>
      <div className="artist-band-card-profile">
        {artist.previewPicture ? <img src={artist.previewPicture} /> : <PiUser />}
      </div>

      <div className="artist-band-name">
        <div className="artist-band-header">{artist.nickname}</div>

        <div className="artist-band-footer">
          <div className="artist-band-footer-content">
            {artist.artistStatus && t(`enum.STATUS.${STATUS[artist.artistStatus]}`)}
          </div>
        </div>
      </div>

      {!displayMode && (
        <>
          <Button
            isClear
            onlyIcon
            variant={BUTTON_VARIANT.remove}
            onClick={(e) => {
              e.stopPropagation();
              onRemove && onRemove();
            }}
          >
            <Button.Icon icon={<PiTrash />} />
          </Button>
        </>
      )}
    </div>
  );
};

export default ArtistBandCard;
